module.exports = __webpack_public_path__ + "img/reimbursement-invoice.fe18748b.svg";